function ease(v: number, pow = 4) {
    return 1 - (1 - v) ** pow;
}

export function createKeyframeAnimation(coords: { x: number; y: number }) {
    const { x, y } = coords;
    const duration = 200;
    const frameTime = 1000 / 60;
    const nFrames = Math.round(duration / frameTime);
    const percentIncrement = 100 / nFrames;
    let animation = '';
    let inverseAnimation = '';

    // eslint-disable-next-line no-plusplus
    for (let step = 0; step <= nFrames; step++) {
        // Remap the step value to an eased one.
        const easedStep = ease(step / nFrames);
        const percentage = step * percentIncrement;

        // Calculate the scale of the element.
        const xScale = x + (1 - x) * easedStep;
        const yScale = y + (1 - y) * easedStep;

        animation += `${percentage}% {
        transform: scale(${xScale}, ${yScale});
      }`;

        // And now the inverse for the contents.
        const invXScale = 1 / xScale;
        const invYScale = 1 / yScale;
        inverseAnimation += `${percentage}% {
        transform: scale(${invXScale}, ${invYScale});
      }`;
    }

    return `
    @keyframes regularAnimation {
      ${animation}
    }
  
    @keyframes inverseAnimation {
      ${inverseAnimation}
    }`;
}
